import { cloneDeep } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import SchemaField from './SchemaField';
import Formsy from 'formsy-react';

export default class ObjectKey extends React.PureComponent {
  static propTypes = {
    formData: PropTypes.any,
    schema: PropTypes.object.isRequired,
    uiSchema: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    fieldID: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      formData: cloneDeep(this.props.formData)
    };
    this.onChange = this.onChange.bind(this);
  }

  componentWillUpdate(nextProps) {
    if (this.props.formData !== nextProps.formData) {
      this.setState({ formData: cloneDeep(nextProps.formData) });
    }
  }

  onChange(formData) {
    this.setState({ formData }, () =>
      this.props.onChange(this.props.fieldID, formData)
    );
  }

  render() {
    const { schema, uiSchema } = this.props;
    const { formData } = this.state;
    return (
      <Formsy.Form>
        <SchemaField
          schema={schema}
          uiSchema={uiSchema}
          formData={formData}
          onChange={this.onChange}
        />
      </Formsy.Form>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Fields/ObjectKey.js